export enum TIERS {
  BASIC = 'BASIC',
  PLATINUM = 'PLATINUM',
  FREE = 'FREE',
  SUPER_ADMIN = 'SUPER_ADMIN',
  DAYPASS = 'DAYPASSNEW'
}
